/* eslint-disable @typescript-eslint/no-explicit-any */
import { ActionTree } from "vuex";
import { RootState } from "../types";
import { MembersInt } from "./types";
import { MembersAPI } from "../../services/accountMembers/index";

export const actions: ActionTree<MembersInt, RootState> = {
  getAccountMembers({ commit }, page) {
    return new Promise((resolve, reject) => {
      MembersAPI.getMembers(page)
        .then((res: any) => {
          resolve(false);
          commit("MEMBERS_FULLFILED", res.data);
        })
        .catch((err) => {
          reject(true);
          commit("MEMBERS_REJECTED", err);
        });
    });
  },
};
